import { render } from "./WriteHeader.vue?vue&type=template&id=63c7dc79"
import script from "./WriteHeader.vue?vue&type=script&lang=js"
export * from "./WriteHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__